import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Column } from 'hedron';

import styled from 'styled-components';
import ds from 'designsystem';

import { desktopBreakpoint } from 'common/responsive';
import { KENTICO_TYPES } from 'common/consts/kentico';
import { ThreeColumnGrid as ThreeColumnGridModel } from 'models';
import Container from 'blocks/Container/Container';
import Carousel from 'blocks/Carousel/Carousel';

import Parser from 'blocks/Parser/Parser';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import ImageLink from 'kentico-blocks/ImageLink';
import ColumnBox from './ColumnBox';

const ThreeColumnGrid = styled.div`
  display: flex;
  padding: 0 0 ${ds.get('metrics.xl')} 0;
`;

ThreeColumnGrid.ColumnBox = ColumnBox;

export default class ThreeColumnGridBlock extends Component {
  static carouselSettings = {
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: desktopBreakpoint,
        settings: {
          slidesToShow: 1,
          dots: true,
          infinite: false,
          arrows: false,
        },
      },
    ],
  };

  static propTypes = {
    data: PropTypes.instanceOf(ThreeColumnGridModel).isRequired,
  };

  render() {
    const {
      data: {
        columns,
        htmlModifiers,
      },
    } = this.props;

    return (
      <HTMLModifiableBackground
        color={ds.brand('background')}
        htmlModifiers={htmlModifiers}
      >
        <Container>
          <ThreeColumnGrid>
            {columns && (
              <Carousel
                settings={ThreeColumnGridBlock.carouselSettings}
                threeColumnCarousel
              >
                {columns.map(el => (
                  <Column
                    key={el.system.id}
                  >
                    {el.system.type === KENTICO_TYPES.IMAGE_LINK
                      ? <ImageLink data={el} />
                      : (
                        <Parser
                          htmlModifiers={el.htmlModifiers}
                          htmlBody={el.content}
                        />
                      )
                    }
                  </Column>
                ))}
              </Carousel>
            )}
          </ThreeColumnGrid>
        </Container>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/ThreeColumnGrid/index.jsx